import type { PreviewMode } from "./FormBlocksProvider";
import { PREVIEW_MODE } from "./FormBlocksProvider";

export const isDesktopPreviewMode = (previewMode: PreviewMode) =>
  previewMode === PREVIEW_MODE.DESKTOP;
export const isMobilePreviewMode = (previewMode: PreviewMode) =>
  previewMode === PREVIEW_MODE.MOBILE;
